import { ProFormaModelIds } from 'constants/proForma';
import { useAuthContext } from 'contexts/AuthContext';
import { useTypedFlags } from './useTypedFlags';

interface AssetType {
    id: number;
    name: string;
}

interface AssetTypeDropdownOption {
    value: string;
    label: string;
    disabled?: boolean;
    disabledTooltip?: string;
}

const useAssetTypeDropdownOptions = (assetTypes: AssetType[]) => {
    const { ldFlagLandDevelopment } = useTypedFlags();
    const { user } = useAuthContext();
    const isNorthspyreUser: boolean = !!user?.email?.toLowerCase().endsWith('@northspyre.com');

    const capitalizeFirstLetter = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

    const resolveAssetTypeProps = (assetTypeId: number) => {
        const assetTypeProps = 
            ({ enabled, disabledMessage }: { enabled: boolean, disabledMessage: string }) => 
                enabled ? {} : ({ disabled: true, disabledTooltip: disabledMessage });

        switch (assetTypeId) {
            case ProFormaModelIds.LAND_DEVELOPMENT:
                return assetTypeProps({ enabled: ldFlagLandDevelopment, disabledMessage: 'Coming in Q2!' });
            case ProFormaModelIds.SELF_STORAGE:
            case ProFormaModelIds.RESIDENTIAL_CONDO:
            case ProFormaModelIds.HOTEL_HOSPITALITY:
                return assetTypeProps({ enabled: isNorthspyreUser, disabledMessage: 'Coming soon!' });
            default:
                return {};
        }
    };

    return assetTypes?.map((assetType: AssetType): AssetTypeDropdownOption => ({
        value: String(assetType.id),
        label: capitalizeFirstLetter(assetType.name),
        ...resolveAssetTypeProps(assetType.id),
    })) || [];
};

export default useAssetTypeDropdownOptions;